// Define the potential locales that we have translation data for in ../locales,
// the locales in this map are always available on the home/search pages.
// The translations that are available for each documentation set are a
// subset of these locales that are defined in the _siteconfig.yaml.
export const LOCALES = {
  'en-US': 'English',
  /* we only support en-US at launch, 
   'ja-JP': '日本語',
  */
};

export const DEFAULT_LOCALE = 'en-US';

export type SUPPORTED_LOCALES = keyof typeof LOCALES;
